/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetProduct } from './assetProduct';


export interface AssetProductResponseDTO { 
    entryCount: number;
    pageEntries: Array<AssetProduct>;
    organisations: Set<string>;
}

